import { VEHICLE_TYPES } from '@/lib/constants';
import { ShipmentVehicleModel } from '@/lib/models/shipment/types';
import { ShipmentJourneyModel } from '@/lib/models/shipment-journey/types';
import { formatDateTimeForUrl, tryParseDate } from '@/utils/format/date-time';

export const getShipmentJourneyVessels = (journey?: ShipmentJourneyModel): ShipmentVehicleModel[] | undefined => {
  if (!journey) return undefined;

  return journey.segments.reduce((accum, segment) => {
    if (segment.vehicle && segment.vehicle.type === VEHICLE_TYPES.VESSEL) {
      const { imoNumber, tripNumber, name } = segment.vehicle;
      const fromDateString = segment.etd || segment.atd;
      const fromDate = tryParseDate(fromDateString);
      const toDateString = segment.eta || segment.ata;
      const toDate = tryParseDate(toDateString);

      const vehicleItem: ShipmentVehicleModel = {
        imoNumber,
        tripNumber,
        name,
        type: segment.mode,
        carrier: '',
        fromDate: fromDate ? formatDateTimeForUrl(fromDate) : undefined,
        toDate: toDate ? formatDateTimeForUrl(toDate) : undefined,
        isActive: !!(segment.atd && !segment.ata), // If there is a DepartureTime, but no ArrivalTime, it is considered activeent.ata || segment.eta || '',
      };
      return [...accum, vehicleItem];
    }
    return accum;
  }, [] as ShipmentVehicleModel[]);
};
